module.exports = __webpack_public_path__ + "img/retouche_la_base_Brunche_450px_haut.ce344012.jpg";